/**
 * Agent Transition Graph – Dubai Police 999 Emergency Assistant
 *
 * Used for pre-warming connections to reduce transition latency.
 * 10-agent intent-first architecture:
 *
 *   greeting_agent → intent_agent
 *   intent_agent → inquiry_agent / human_handoff_agent / followup_agent
 *   followup_agent → intent_agent (clarification loop)
 *   inquiry_agent → image_upload_agent / closing_agent
 *   image_upload_agent → agency_agent
 *   agency_agent → incident_card_agent
 *   incident_card_agent → closing_agent
 *   human_handoff_agent → closing_agent
 *   closing_agent → intent_agent (loop)
 */

export const AGENT_TRANSITION_GRAPH: Record<string, string[]> = {
  'greeting_agent':     ['intent_agent'],
  'intent_agent':       ['inquiry_agent', 'image_upload_agent', 'human_handoff_agent', 'followup_agent'],
  'followup_agent':     ['intent_agent'],
  'inquiry_agent':      ['image_upload_agent', 'closing_agent'],
  'image_upload_agent': ['agency_agent', 'incident_card_agent'],
  'agency_agent':       ['incident_card_agent'],
  'incident_card_agent':['closing_agent'],
  'human_handoff_agent':['closing_agent'],
  'closing_agent':      ['intent_agent'],
};

export function getLikelyNextAgents(currentAgentId: string): string[] {
  return AGENT_TRANSITION_GRAPH[currentAgentId] || [];
}

export function hasPrewarmTargets(agentId: string): boolean {
  const targets = AGENT_TRANSITION_GRAPH[agentId];
  return targets !== undefined && targets.length > 0;
}

export function getAllAgentsInGraph(): string[] {
  const all = new Set<string>();
  Object.keys(AGENT_TRANSITION_GRAPH).forEach(a => all.add(a));
  Object.values(AGENT_TRANSITION_GRAPH).forEach(ts => ts.forEach(t => all.add(t)));
  return Array.from(all);
}
